import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Badge, Button, Spinner, Alert, Row, Col, Modal, Card } from 'react-bootstrap';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaArrowLeft, FaBoxes, FaCalendarAlt, FaEdit, FaUser } from 'react-icons/fa';
import { FiDownload, FiZoomIn } from "react-icons/fi";
import Select from 'react-select';


const ProductionOrederView = () => {
  const { id, pointindex } = useParams();
  const navigate = useNavigate();
  const [imageBlobs, setImageBlobs] = useState({});

  const [images, setImages] = useState([]);
  const [fileType, setFileType] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [modalShow, setModalShow] = useState(false);

  const [productionOrder, setProductionOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Add to useState
  const [showInwardModal, setShowInwardModal] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [inwarddate, setInwardDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0]; 
  });


  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const response = await axios.get(`${BASE_URL}warehouse/findAllWarehouse`, {
          headers: authHeader()
        });
        const options = response.data.map(w => ({
          value: w.id,
          label: w.warehousename
        }));
        setWarehouses(options);
      } catch (error) {
        console.error('Error fetching warehouses:', error);
      }
    };

    if (showInwardModal) {
      fetchWarehouses();
    }
  }, [showInwardModal]);

//   const handleInwardSubmit = async () => {
//   if (!selectedWarehouse) {
//     return Swal.fire('Warning', 'Please select a warehouse', 'warning');
//   }

//   try {
//     await axios.put(`${BASE_URL}productionorder//update/warehouse/{poid}/{warehouseId}/{inwarddate}/${id}`, {
//       warehouseId: selectedWarehouse.value,
//       inwarddate: inwarddate,
//     }, {
//       headers: authHeader()
//     });

//     Swal.fire('Success', 'Inward updated successfully!', 'success');
//     setShowInwardModal(false);
//   } catch (error) {
//     console.error('Inward update error:', error);
//     Swal.fire('Error', 'Failed to update inward data.', 'error');
//   }
// };


const handleInwardSubmit = async () => {
  if (!selectedWarehouse) {
    return Swal.fire('Warning', 'Please select a warehouse', 'warning');
  }

  if (!inwarddate) {
    return Swal.fire('Warning', 'Please select an inward date', 'warning');
  }

  try {
    const url = `${BASE_URL}productionorder/update/warehouse/${id}/${selectedWarehouse.value}/${inwarddate}`;

    await axios.put(url, {}, {
      headers: authHeader(),
    });

    Swal.fire('Success', 'Inward details updated successfully!', 'success');
    setShowInwardModal(false);
  } catch (error) {
    console.error('Error updating inward details:', error);
    Swal.fire('Error', 'Failed to update inward details', 'error');
  }
};




  const statusColor = {
    Open: 'primary',
    Ongoing: 'warning',
    'On Hold': 'danger',
    Complete: 'success',
    Cancelled: 'secondary',
    Closed: 'dark'
  };


  useEffect(() => {
    const fetchProductionOrderData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}productionorder/${id}`, {
          headers: authHeader()
        });
        setProductionOrder(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching production order data', error);
        setError('Failed to fetch production order data');
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch production order data',
          confirmButtonText: 'OK'
        }).then(() => {
          navigate("/Porderindex/1");
        });
      }
    };

    const fetchImages = async () => {
      try {
        const res = await axios.get(`${BASE_URL}productionorder/getimages/${id}`, {
          headers: authHeader()
        });
        setImages(res.data || []);
      } catch (err) {
        console.error("Error fetching images", err);
      }
    };

    fetchProductionOrderData();
    fetchImages();
  }, [id, navigate]);

  useEffect(() => {
    const fetchAllImageBlobs = async () => {
      const blobs = {};
      for (const img of images) {
        try {
          const response = await axios.get(`${BASE_URL}productionorder/singleimages/view/${img.id}`, {
            headers: authHeader(),
            responseType: 'blob',
          });
          const url = URL.createObjectURL(response.data);
          blobs[img.id] = url;
        } catch (err) {
          console.error("Error fetching image blob for id:", img.id, err);
        }
      }
      setImageBlobs(blobs);
    };

    if (images.length > 0) {
      fetchAllImageBlobs();
    }
  }, [images]);


  // Fetch and open file by image ID
  const fetchAndOpenFileById = async (imageId) => {
    try {
      const response = await axios.get(`${BASE_URL}productionorder/singleimages/view/${imageId}`, {
        headers: authHeader(),
        responseType: 'blob',
      });
      const contentType = response.headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const url = URL.createObjectURL(blob);

      setFileType(contentType.startsWith('image') ? 'image' : 'pdf');
      setFileUrl(url);
      setModalShow(true);
    } catch (error) {
      console.error('Error viewing file:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to open file.',
      });
    }
  };

  const downloadFileById = async (imageId, filename) => {
    try {
      const response = await axios.get(`${BASE_URL}productionorder/singleimages/view/${imageId}`, {
        headers: authHeader(),
        responseType: 'blob',
      });

      const fileExtension = filename.split('.').pop().toLowerCase();
      const contentTypeMap = {
        'pdf': 'application/pdf',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
      };
      const contentType = contentTypeMap[fileExtension] || 'application/octet-stream';

      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Download Failed',
        text: 'Could not download file.',
        confirmButtonColor: "#0d6efd",
      });
    }
  };


  const handleCloseModal = () => {
    setModalShow(false);
    setFileUrl(null);
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="container text-center mt-5">
        <Spinner animation="border" variant="primary" role="status" />
        <p className="mt-2">Loading production order details...</p>
      </div>
    );
  }

  if (error || !productionOrder) {
    return (
      <div className="container mt-5">
        <Alert variant="danger">{error || "Production order not found"}</Alert>
        <Button variant="primary" onClick={handleBack} className="mt-3">
          <FaArrowLeft className="me-2" /> Back to List
        </Button>
      </div>
    );
  }

  const renderImages = () => (
    <div className="gallery-container">
      {images.length ? (
        <Row xs={1} md={2} lg={3} className="g-3">
          {images.map((img) => (
            <Col key={img.id}>
              <Card className="shadow-sm h-100">
                <Card.Img
                  variant="top"
                  src={imageBlobs[img.id] || '/placeholder.png'}
                  alt={img.filename}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                <Card.Body className="d-flex flex-column justify-content-between">
                  <div className="mb-2 text-truncate" title={img.filename} style={{ fontSize: '0.9rem' }}>
                    {img.filename}
                  </div>

                  <div className="d-flex justify-content-between mt-auto">
                    <Button
                      variant="outline-success"
                      size="sm"
                      title="View File"
                      onClick={() => fetchAndOpenFileById(img.id)}
                    >
                      <FiZoomIn className="me-1" /> View
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      title="Download File"
                      onClick={() => downloadFileById(img.id, img.filename)}
                    >
                      <FiDownload className="me-1" /> Download
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

      ) : (
        <div className="no-files text-center py-4">
          <p className="text-muted">No images available for this production order</p>
        </div>
      )}
    </div>

  );

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}productionorder/${id}`, {
          headers: authHeader(),
        });
        navigate(`/Porderindex/${pointindex}`);
        Swal.fire('Deleted!', 'production order successfully.', 'success');
      } catch (error) {
        // If there is an error, display it
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };




  return (
    <div className="Container">
      <Card className="card">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="fw-bold text-primary">Type: {productionOrder.type}</h5>
          <h6>VIEW PRODUCTION ORDER</h6>
          <div className="d-flex justify-content-end gap-2 mb-4">


            <Link to={`/PorderUpdate/${id}/${pointindex}`}>
              <Button variant="primary" className="me-2" size='sm'> <FaEdit className="me-2" />UPDATE</Button>
            </Link>

            <Button variant="danger" className="me-2" size='sm' onClick={() => handleDelete(id)}>DELETE</Button>
            <Link to={`/Porderindex/${pointindex}`}>
              <Button variant="outline-secondary" className="me-2" size='sm'> <FaArrowLeft className="me-2" />BACK TO LIST</Button>
            </Link>

            {/* {productionOrder.status === 'Closed' && (
              <Button variant="success" size="sm" onClick={() => navigate(`/inward/${id}`)}>
                <FaBoxes className="me-2" /> INWARD
              </Button>
            )} */}

            {productionOrder.status === 'Closed' && (
              <Button variant="success" size="sm" onClick={() => setShowInwardModal(true)}>
                <FaBoxes className="me-2" /> INWARD
              </Button>
            )}

          </div>
        </div>
        <div className="container py-4">
          <div className="mb-4 border">
            <div className="bg-light p-2 mb-3">
              <h5 className="mb-0">Basic Information</h5>
            </div>
            <div className="d-flex flex-wrap p-3">
              {/* order info */}
              <div className="mb-3 me-4 flex-fill" style={{ minWidth: '250px' }}>
                <label className="form-label fw-bold">Order Number</label>
                <p className="text-muted">{productionOrder.productionordernumber}</p>
              </div>
               <div className="mb-3 me-4 flex-fill" style={{ minWidth: '250px' }}>
                <label className="form-label fw-bold">Part Number</label>
                <p className="text-muted">{productionOrder.partno}</p>
              </div>
              <div className="mb-3 me-4 flex-fill" style={{ minWidth: '250px' }}>
                <label className="form-label fw-bold">Job Number</label>
                <p className="text-muted">{productionOrder.jobnumber}</p>
              </div>
              <div className="mb-3 me-4 flex-fill" style={{ minWidth: '250px' }}>
                <label className="form-label fw-bold">Status</label>
                <p>
                  <Badge pill bg={statusColor[productionOrder.status] || 'secondary'}>
                    {productionOrder.status}
                  </Badge>
                </p>
              </div>
              <div className="mb-3 flex-fill" style={{ minWidth: '250px' }}>
                <label className="form-label fw-bold">Order Date</label>
                <p className="text-muted">
                  <FaCalendarAlt className="me-2" />
                  {new Date(productionOrder.productionorderdate).toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>

          {/* Customer and Operator Info */}
          <div className="mb-4 border">
            <div className="bg-light p-2 mb-3">
              <h5 className="mb-0">Customer And Operator Information</h5>
            </div>
            <div className="d-flex flex-wrap p-3">
              <div className="mb-3 me-4 flex-fill" style={{ minWidth: '300px' }}>
                <label className="form-label fw-bold">Customer Name</label>
                <p className="text-muted">
                  <FaUser className="me-2" />
                  {productionOrder.customer?.companyname || 'N/A'}
                </p>
              </div>
              <div className="mb-3 flex-fill" style={{ minWidth: '300px' }}>
                <label className="form-label fw-bold">Operator(s)</label>
                <p className="text-muted">
                  <FaUser className="me-2" />
                  {productionOrder.operator?.length > 0
                    ? productionOrder.operator.map(op => `${op.firstname} ${op.firstname}`).join(', ')
                    : 'N/A'}
                </p>
              </div>
            </div>
          </div>

          {/* Schedule Info */}
          <div className="mb-4 border">
            <div className="bg-light p-2 mb-3">
              <h5 className="mb-0">Schedule Information</h5>
            </div>
            <div className="d-flex flex-wrap p-3">
              {[{ label: 'Inhouse Start Date', value: productionOrder.inhousestartdate },
              { label: 'Inhouse End Date', value: productionOrder.inhouseenddate },
              { label: 'Outward Jobwork Date', value: productionOrder.outwardjobworkdate },
              { label: 'Inward Jobwork Date', value: productionOrder.inwardjobworkdate }]
                .map((item, idx) => (
                  <div key={idx} className="mb-3 me-4 flex-fill" style={{ minWidth: '250px' }}>
                    <label className="form-label fw-bold">{item.label}</label>
                    <p className="text-muted">
                      <FaCalendarAlt className="me-2" />
                      {item.value ? new Date(item.value).toLocaleDateString() : 'N/A'}
                    </p>
                  </div>
                ))}
            </div>
          </div>

          {/* Order Items */}
          <div className="mb-4 border">
            <div className="bg-light p-2 mb-3">
              <h5 className="mb-0">
                <FaBoxes className="me-2" /> Order Items
              </h5>
            </div>
            <div className="p-3 table-responsive">
              <Table striped bordered hover className="mb-0">
                <thead className="table-dark">
                  <tr>
                    <th>Product Name</th>
                    <th>Quantity</th>
                    <th>unit of measurement</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {productionOrder.popumpitems?.length > 0 ? (
                    productionOrder.popumpitems.map((item, index) => (
                      <tr key={index}>
                        <td>{item.bomproductname || 'N/A'}</td>
                        <td>{item.quantity || 0}</td>
                        <td>{item.uom || 'N/A'}</td>
                        <td>{item.ramarks || 'N/A'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted">No items found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>

          {/* Images Section */}
          <div className="mb-4 border">
            <div className="bg-light p-2 mb-3">
              <h5 className="mb-0">Images</h5>
            </div>
            <div className="p-3">{renderImages()}</div>
          </div>

          {/* Back Button */}
          <div className="mb-4">
            <Button variant="secondary" onClick={handleBack}>
              <FaArrowLeft className="me-2" />
              Back
            </Button>
          </div>

          {/* Modal for View */}
          <Modal show={modalShow} onHide={handleCloseModal} size="lg" centered>
            <Modal.Header closeButton>
              <Modal.Title>View File</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              {fileType === 'image' && <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '70vh' }} />}
              {fileType === 'pdf' && (
                <iframe
                  src={fileUrl}
                  title="PDF Preview"
                  width="100%"
                  height="600px"
                ></iframe>
              )}
              {!fileType && <p>No preview available</p>}
            </Modal.Body>
          </Modal>

          <Modal show={showInwardModal} onHide={() => setShowInwardModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Inward Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3">
                <label className="form-label">Select Warehouse</label>
                <Select
                  options={warehouses}
                  value={selectedWarehouse}
                  onChange={setSelectedWarehouse}
                  placeholder="Choose warehouse..."
                />
              </div>


              <div className="mb-3">
                <label className="form-label">Inward Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={inwarddate}
                  onChange={(e) => setInwardDate(e.target.value)}
                />
              </div>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowInwardModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleInwardSubmit}>Submit</Button>
            </Modal.Footer>
          </Modal>

        </div>
      </Card>
    </div>
  );
};

export default ProductionOrederView;
